<template>

  <form @submit.prevent="save">

    <card class="p-col-12" :header="$t(cardHeader)">

      <coff-input-auto-complete v-model="form.client" label="forms.add-client.client" class="p-col-11 p-md-6 p-lg-4" :itens="clients" field="name" :func-suggestions="searchClient" :error="validation.client"/>
      <a class="cursor-pointer p-col-1 p-md-1 p-lg-1" @click.prevent="modalClientForm" style="margin-top: 30px;"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>
      <div class="p-col-12">
        <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
      </div>

    </card>

  </form>

</template>

<script>
import ValidationUtils from "@/utils/ValidationUtils";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import Utils from "@/utils/Utils";
import ClientBusiness from "@/business/ClientBusiness";
import ModalClientForm from "@/viewer/client/ModalClientForm";
import DialogService from "@/business/ModalBusiness";

export default {
  name: "CardFormClient",

  async mounted(){
    this.clients =  await ClientBusiness.getAll();
    if(this.paramComponent.protocolClient) this.form = Utils.safetyClone(this.paramComponent.protocolClient);
    if(this.paramComponent.clientsProtocolId) {
      this.clients = this.clients.filter((c) => {
        if (this.form?.client?.id === c.id) {
          return true
        } else {
          return !this.paramComponent.clientsProtocolId.includes(c.id);
        }
      });
    }
  },

  props:{
    protocol: {type: Object, default: () => {}},
    paramComponent: {type: Object, default: null},
  },

  computed:{

    cardHeader(){
      return `forms.add-client.${this.form?.id ? 'edit' : 'add'}-card-header`;
    }

  },

  data(){
    return {
      form: {},
      validation: {
        client: false,
      },
      clients: [],
    }
  },

  methods:{

    cleanForm(){
      this.form = {};
      this.validation = {
        client: false,
      };
    },

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        const response = await ProtocolBusiness.saveProtocolClient(this.form, this.protocol.id, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.$emit('success', response);
          ToastMessageBusiness.showSuccess();
          this.cleanForm();
        }
      }
    },

    async searchClient(name){
      return await ClientBusiness.search(name);
    },

    async modalClientForm(){
      const client = await DialogService.openModal(ModalClientForm, {}, 1000);
      if(client){
        this.$set(this.form, 'client', client);
      }
    }

  }

}
</script>

<style scoped>

</style>